// extracted by mini-css-extract-plugin
module.exports = {"promotorBubble":"PromotorBubble_promotorBubble__lbPBD","title":"PromotorBubble_title__DiXEt"};